const reasonsForDeactivating = [
  {
    label: 'Refinement Required',
    value: 'Refinement Required',
  },
  {
    label: 'Treatment dropout',
    value: 'Treatment dropout',
  },
  {
    label: 'Others',
    value: 'Others',
  },
]

export default reasonsForDeactivating
